exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".close-btn[data-v-7e633720]{right:8px;top:8px}.card[data-v-7e633720]{height:auto;max-height:90%;overflow-y:auto}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/Validate.vue"],"names":[],"mappings":"AACA,4BACE,UAAW,AACX,OAAS,CACV,AACD,uBACE,YAAa,AACb,eAAgB,AAChB,eAAiB,CAClB","file":"Validate.vue","sourcesContent":["\n.close-btn[data-v-7e633720] {\n  right: 8px;\n  top: 8px;\n}\n.card[data-v-7e633720] {\n  height: auto;\n  max-height: 90%;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e633720","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/Validate.vue
// module id = 530
// module chunks = 13